import {
  SYS_BREAKPOINT_MD,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_250,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_RELATIVE_4_XL,
  SYS_SPACE_RELATIVE_6_XL,
  SYS_SPACE_RELATIVE_LG,
} from '@oneaudi/unified-web-common';
import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

export const CEContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
export const CEHeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_200};
  margin-bottom: ${SYS_SPACE_RELATIVE_LG};
`;
export const CEValueList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 288px;
  max-width: 390px;
  gap: ${SYS_SPACE_FIXED_350};
  align-self: stretch;
  margin-bottom: ${SYS_SPACE_RELATIVE_4_XL};
`;
export const CEValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${SYS_SPACE_FIXED_250};
  align-items: flex-start;
  align-self: stretch;
`;
export const CEValue = styled(Text)`
  display: flex;
  flex-wrap: nowrap;
  flex-shrink: 0;
`;
export const CECLabelFigure = styled.figure<{ imageUrl: string }>`
  background: url(${(props): string => props.imageUrl}) no-repeat left top;
  background-size: contain;
  margin: 0;
  overflow: hidden;
  height: 174px;
  width: 240px;
  max-width: 284px;
`;
export const ResponsiveLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  gap: 0 ${SYS_SPACE_RELATIVE_6_XL};
  align-self: stretch;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
  }
`;
export const StyledFootnoteContainer = styled.div`
  & > * {
    background-color: transparent !important;
  }
`;
export const EfficiencyDisplayContainer = styled.div`
  margin-bottom: ${SYS_SPACE_RELATIVE_4_XL};
`;
